var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcToken(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2C6.98 2 2.5 6.48 2.5 12C2.5 17.52 6.98 22 12.5 22C18.02 22 22.5 17.52 22.5 12C22.5 6.48 18.02 2 12.5 2ZM12.5 20C8.09 20 4.5 16.41 4.5 12C4.5 7.59 8.09 4 12.5 4C16.91 4 20.5 7.59 20.5 12C20.5 16.41 16.91 20 12.5 20ZM13.39 11.1C11.61 10.51 10.75 10.14 10.75 9.2C10.75 8.18 11.86 7.81 12.56 7.81C13.87 7.81 14.35 8.8 14.46 9.15L16.04 8.48C15.89 8.04 15.22 6.57 13.38 6.25V5H11.63V6.26C9.03 6.82 9.01 9.11 9.01 9.22C9.01 11.49 11.26 12.13 12.36 12.53C13.94 13.09 14.64 13.6 14.64 14.56C14.64 15.69 13.59 16.17 12.66 16.17C10.84 16.17 10.32 14.3 10.26 14.08L8.6 14.75C9.23 16.94 10.88 17.53 11.62 17.71V19H13.37V17.76C13.89 17.67 16.39 17.17 16.39 14.54C16.4 13.15 15.79 11.93 13.39 11.1Z",
    fill: "#3D454D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcToken);
export default __webpack_public_path__ + "static/media/ic_token.456ebfae1c148916b89361f754b2396c.svg";
export { ForwardRef as ReactComponent };